import { BasicModal } from "@similarweb/ui-components";
import { swSettings } from "app/common/services/swSettings";
import { AssetsService } from "app/services/AssetsService";
import { i18nFilter } from "app/filters/i18nFilter";
import {
    ButtonsContainer,
    Container,
    Subtitle,
    TextContainer,
    Title,
} from "app/components/UsersAddOnModal/UsersAddOnModalStyled";
import { Button } from "@similarweb/ui-components";
import type { Dispatch, SetStateAction, FC } from "react";
import { useEffect } from "react";
import {
    getAddOnsUrl,
    MODAL_CONFIG,
    TEAM_INVITE_IMAGE,
    TRACKING_CATEGORY,
    TRACKING_EVENT_NAME,
} from "app/components/UsersAddOnModal/consts";
import { postUpdateShowModal } from "app/components/UsersAddOnModal/userAddOnFetcher";
import { allTrackers } from "app/services/track/track";

interface IUsersAddOnModalProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const UsersAddOnModal: FC<IUsersAddOnModalProps> = ({ isOpen, setIsOpen }) => {
    const i18n = i18nFilter();
    const userName = swSettings?.user?.firstname;

    useEffect(() => {
        allTrackers.dispatchTrackEvent(TRACKING_CATEGORY, "open", TRACKING_EVENT_NAME);
    }, []);

    const handleCloseModal = (withTracking = true) => {
        if (withTracking) {
            allTrackers.dispatchTrackEvent(TRACKING_CATEGORY, "close", `${TRACKING_EVENT_NAME}/Maybe later`);
        }

        setIsOpen(false);
        postUpdateShowModal();
    };

    const handleAddOnsClick = () => {
        window.open(getAddOnsUrl(), "_blank");
        allTrackers.dispatchTrackEvent(TRACKING_CATEGORY, "click", `${TRACKING_EVENT_NAME}/go to add-ons`);
        handleCloseModal(false);
    };

    return (
        <BasicModal
            isOpen={isOpen}
            closeIconConfig={MODAL_CONFIG.closeIcon}
            customStyles={MODAL_CONFIG.styles}
        >
            <Container>
                <img
                    src={AssetsService.assetUrl(TEAM_INVITE_IMAGE)}
                    alt="invite team"
                />
                <TextContainer>
                    <Title>
                        {i18n("UsersAddOnModal.title", {
                            name: userName,
                        })}
                    </Title>
                    <Subtitle>{i18n("UsersAddOnModal.text")}</Subtitle>
                </TextContainer>
                <ButtonsContainer>
                    <Button
                        type="primary"
                        onClick={handleAddOnsClick}
                    >
                        {i18n("UsersAddOnModal.ctaButtonText")}
                    </Button>
                    <Button
                        type="flat"
                        onClick={handleCloseModal}
                    >
                        {i18n("UsersAddOnModal.closeButtonText")}
                    </Button>
                </ButtonsContainer>
            </Container>
        </BasicModal>
    );
};

export default UsersAddOnModal;
